import React from 'react'
import { Routes, Route } from 'react-router-dom'

import Invoices from '../pages/Partner/Invoices.page'
import Payments from '../pages/Partner/Payments.page'
import Statistics from '../pages/Partner/Statistics.page'
import Withdraws from '../pages/Partner/Withdraw.page'


const partnerRoutes = (
    <Routes>
        <Route path="/" element={<Statistics />} exact />
        <Route path="/invoices" element={<Invoices />} exact />
        <Route path="/payments" element={<Payments />} exact />
        <Route path="/withdraws" element={<Withdraws />} exact />

        <Route path="*" element={<Statistics />} exact />
    </Routes>
)     

export default partnerRoutes